// @flow
import React from 'react'
import styled from 'styled-components'
import { Title, NewLogo, YellowPattern, GreenPattern } from 'src/theme/globalStyle'
import { media } from 'src/theme/style-utils'

import { StyledFormPage, StyledArticle, FieldCollection } from 'src/components/Form'

const StyledTerms = styled(StyledArticle)`
  display: flex;
  margin-top: 120px !important;
  justify-content: center;
`

const StyledThanks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  li {
    margin-bottom: 20px;
  }

  ${media.tabletLarge`
    width: 100%;
  `};
  ${media.desktop`
    width: 60%;
  `};
`

const CancellationOl = styled.ul`
  counter-reset: line-number;
  margin-left: 10px;
  padding-left: 0;

  li {
    list-style: none;

    counter-increment: line-number;
    ::before {
      margin-left: -33px;
      content: '13.' counters(line-number, '.') '. ';
    }
  }
`

const Terms = () => (
  <StyledFormPage>
    <NewLogo />
    <YellowPattern />
    <GreenPattern />
    <StyledTerms>
      <StyledThanks>
        <FieldCollection hasShadow>
          <Title>Terms and conditions</Title>
          <ol>
            <li>
              You confirm that the information provided in this application form is true, accurate
              and not misleading.
            </li>

            <li>
              {`You will be charged a one-off joining fee (the "Membership Joining Fee") in
                    order to make this application. The Membership Joining Fee is non-refundable.`}
            </li>

            <li>
              {`You will be charged a Holding Deposit which is equivalent to one week's Licence
                    Fee (the "Holding Deposit"). Once you sign your Membership Agreement, you will
                    be required to pay the first instalment of your Licence Fee and the Security
                    Bond. The Security Bond will be held on trust for the Member in a separate
                    designated account by The Collective until the end of the Membership Period.`}
            </li>

            <li>
              The Holding Deposit will only be repaid to you in full if in our sole discretion, we
              decide after receiving your verification documents (which for the avoidance of doubt
              must be received by us not later than 10 days from completion of this application
              form), not to enter into the membership agreement with you.
            </li>

            <li>
              If your application is successful and you enter into a Membership Agreement with us,
              your Holding Deposit will be deducted from the first instalment of your Licence Fee.
            </li>

            <li>
              You will have 10 days from completing this application form to submit the verification
              documents requested. If you do not submit these documents within 10 days of submitting
              this application form, you will lose the Membership Joining Fee. In the event that
              your move-in date is less than 10 days after completing this form, you will need to
              submit the verification documents at least one day before your move-in date, otherwise
              we shall be entitled to cancel your application and retain the Membership Joining Fee
              and Holding Deposit.
            </li>

            <li>
              Salary threshold is 2 times your annual Licence Fee. If you do not meet the salary
              thresholds or credit score, you have three options:
              <ol>
                <li>
                  Pay an amount equal to 2 weeks licence fee as a Security Bond, if you find a UK
                  based guarantor that meet the salary thresholds
                </li>

                <li>
                  Pay an amount equal to 2 weeks Licence Fee as a Security Bond, if you pay the
                  entire Licence Fee upfront
                </li>
                <li>
                  Pay an amount equal to 5 weeks Licence Fee as a Security Bond to allow a monthly
                  licence fee payment option
                </li>
              </ol>
            </li>

            <li>
              If you choose option 1 you must ensure that your guarantor lives in the UK and they
              will be required to provide any verification documents as requested. You authorise us
              to conduct credit checks on you and your guarantor for the purpose of this
              application.
            </li>

            <li>
              You confirm that the annual income which you have stated in this application form is
              correct.
            </li>

            <li>
              By submitting the application form, you agree for us to use your details to conduct a
              credit check using Credit Safe.
            </li>

            <li>
              If you submit this application form and fail to pass your credit check, your
              application will be cancelled, and the Membership Joining Fee will be repaid to you.
            </li>

            <li>
              The Membership Joining Fee is non-refundable in any circumstance other than as
              described above in clause 11. If you decide, after submission of this application
              form, not to enter into the Membership Agreement for any reason whatsoever, the
              Membership Joining Fee will not be repaid to you.
            </li>

            <li>
              <h4>Cancellation policy</h4>

              <CancellationOl>
                <li>
                  The Membership Joining Fee and the Holding Deposit are non-refundable should you
                  decide to cancel your application before entering into a Membership Agreement with
                  us. By submitting the application form, you agree for us to use your details to
                  conduct a credit check using credit.
                </li>

                <li>
                  We are permitted to cancel you application if you fail to pass the credit check.
                  In this circumstance, the Membership Joining Fee and the Holding Deposit will be
                  refunded back to you.
                </li>
              </CancellationOl>
            </li>
          </ol>
        </FieldCollection>
      </StyledThanks>
    </StyledTerms>
  </StyledFormPage>
)
export default Terms



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/Terms/Terms.js